export default __webpack_public_path__ + "static/media/profile_image.9b046b59.png";